import React, {useEffect, useState} from "react";
import Loading from "../Loading";
import {useParams, useNavigate} from "react-router-dom";
import {
    Breadcrumbs,
    ButtonPrimary,
    Heading,
    IconChevronRight20,
    IconPlane20,
    Link,
    Text,
    ToggleSwitch
} from "pac-ux-components";
import Add24 from "pac-ux-components/build/Icons/Navigation/Add24";
import {disableStore, enableStore} from "../store/StoreActions";
import {useCookies} from "react-cookie";

function MerchantProfile() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [merchantProfiles, setMerchantProfiles] = useState([]);
    const [store, setStore] = useState({});
    const [tenant, setTenant] = useState({});
    const [PSPs, setPSPs] = useState({});
    const {storeId, tenantId} = useParams();
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }
    const navigate = useNavigate();


    const handleEnableStore = (store) => enableStore(apiRoot, cookies.idToken, tenant.id, store, () => {
        setStore((prevStore) => ({...prevStore, enabled: true}));
    }, setError);
    const handleDisableStore = (id) => disableStore(apiRoot, cookies.idToken, tenant.id, id, () => {
        setStore((prevStore) => ({...prevStore, enabled: false}));
    }, setError);

    async function getMerchantProfiles() {
        const response = await fetch(apiRoot + '/backoffice/tenants/' + tenantId + '/stores/' + storeId + '/merchant-profiles?size=100', {headers: apiHeaders});
        const data = await response.json();
        console.log(data.content);
        setMerchantProfiles(data.content);
    }

    async function getPSPs() {
        const response = await fetch(apiRoot + '/backoffice/payment-service-providers?size=100', {headers: apiHeaders});
        const data = await response.json();
        const pspsById = data.content.reduce((acc, psp) => {
            acc[psp.id] = psp;
            return acc;
        }, {});
        setPSPs(pspsById);
    }

    async function getStoreDetails() {
        const response = await fetch(apiRoot + '/backoffice/tenants/' + tenantId + '/stores/' + storeId, {headers: apiHeaders});
        const data = await response.json();
        setStore(data);
    }

    async function getTenantDetails() {
        const response = await fetch(apiRoot + '/backoffice/tenants/' + tenantId, {headers: apiHeaders});
        const data = await response.json();
        setTenant(data);
    }

    async function handleEnableMerchantProfile(merchantProfile) {
        merchantProfile.enabled = true;
        try {
            const response = await fetch(`${apiRoot}/backoffice/payment-service-providers/${merchantProfile.paymentProviderId}/merchant-profiles/${merchantProfile.id}`, {
                method: 'PUT',
                headers: apiHeaders,
                body: JSON.stringify(merchantProfile),
            });

            if (!response.ok) {
                throw new Error('Failed to enable store');
            }
            setMerchantProfiles((prevMerchantProfile) => prevMerchantProfile.map((mp) => (mp.id === merchantProfile.id ? {
                ...mp, enabled: true
            } : mp)));
        } catch (error) {
            setError(error);
        }
    }

    async function handleDisableMerchantProfile(merchantProfile) {
        merchantProfile.enabled = true;
        try {
            const response = await fetch(`${apiRoot}/backoffice/payment-service-providers/${merchantProfile.paymentProviderId}/merchant-profiles/${merchantProfile.id}`, {
                method: 'DELETE', headers: apiHeaders,
                body: JSON.stringify(merchantProfile.id),
            });

            if (!response.ok) {
                throw new Error('Failed to enable store');
            }
            setMerchantProfiles((prevMerchantProfile) => prevMerchantProfile.map((mp) => (mp.id === merchantProfile.id ? {
                ...mp, enabled: false
            } : mp)));
        } catch (error) {
            setError(error);
        }
    }

    useEffect(() => {
        // Define an async function inside useEffect
        const fetchData = async () => {
            await getPSPs();
            await getTenantDetails();
            await getStoreDetails();
            await getMerchantProfiles();
            setLoading(false); // Only set loading to false after the data is fetched
        };
        fetchData();
    }, []);

    if (loading) return (<Loading/>);
    if (error) return <p>Error: {error}</p>;

    return (<div className="MerchantProfiles" style={{width: 1047}}>
        <Breadcrumbs
            style={{height: 24}}
        >
            <Link
                style={{color: '#2264A0'}}
                as="a" href="/stores" underline="none">Stores</Link>
            <Text>Merchant Profiles</Text>
        </Breadcrumbs>

        <Heading color={'#10304C'} style={{paddingTop: 32, paddingBottom: 16}}>Merchant Profiles</Heading>
        <div>Select a merchant profile to edit details.</div>

        <div style={{display: 'flex', alignItems: 'center', marginTop: 24, fontSize: 16}}>
            <div style={{display: 'flex', gap: '10px'}}>
                <div style={{width: 200, height: 24}}><IconPlane20 style={{marginRight: 4}}/> {tenant.name}</div>
                <div>
                    <div style={{width: 240, height: 24}}>
                        <span style={{fontWeight: 600}}>Store: </span>{store.name}</div>
                </div>
                <div>
                    <div style={{height: 24, width: 200}}>
                        <span style={{float: 'left', marginRight: 6, marginTop: 2, fontWeight: 600}}>Enable
                        </span>
                        <ToggleSwitch style={{float: 'left'}}
                                      onClick={() => store.enabled ? handleDisableStore(store.id) : handleEnableStore(store)}
                                      checked={store.enabled}>
                            {store.enabled ? 'On' : 'Off'}
                        </ToggleSwitch>
                    </div>
                </div>

            </div>

            <div style={{marginLeft: 'auto'}}><ButtonPrimary
                onClick={() => {
                    console.log("click");
                    navigate(window.location.pathname + '/merchant-profile/add');
                }}
            ><Add24/> Add Merchant Profile </ButtonPrimary></div>
        </div>

        <table width="100%" className="Table" style={{marginTop: 24}}>
            <thead>
            <tr style={{
                fontWeight: 600, height: 48, fontSize: 16, fontFamily: 'Inter', border: "thin solid #E0E0E0"
            }}>
                <td width="300" style={{paddingLeft: 32}}>Merchant Profile</td>
                <td width="300">Payment Provider</td>
                <td width="300">Store</td>
                <td>Enable</td>
                <td></td>
            </tr>
            </thead>
            <tbody>
            {merchantProfiles.map((profile, index) => <tr key={profile.id} style={{
                height: 48,
                fontSize: 16,
                fontWeight: 400,
                backgroundColor: index % 2 === 0 ? '#EDEDED' : '#FFFFFF',
                border: "thin solid #E0E0E0"
            }}>
                <td style={{paddingLeft: 32, cursor: 'pointer'}}>
                    {profile.name}
                </td>
                <td>
                    {PSPs[profile.paymentProviderId].name}
                </td>
                <td>
                    {store.name}
                </td>
                <td>
                    <ToggleSwitch
                        checked={profile.enabled}
                        style={{width: 180}}
                        onClick={async () => {
                            profile.enabled ? await handleDisableMerchantProfile(profile) : await handleEnableMerchantProfile(profile)
                        }}
                    >{profile.enabled ? 'On' : 'Off'}</ToggleSwitch>
                </td>
                <td style={{paddingRight: 8}}>
                    <a href={'/tenants/' + tenantId + '/stores/' + storeId + '/psp/' + profile.paymentProviderId + '/merchant-profile/' + profile.id}>
                        <IconChevronRight20
                            style={{color: 'black'}}
                        />
                    </a>
                </td>
            </tr>)}
            </tbody>
        </table>
    </div>);
}

export default MerchantProfile;
